import { GenericHeader } from "../../Components/GenericHeader/GenericHeader";
import { Footer } from "../../Components/Footer/Footer";
import React from "react";
import { noticePrivacyCSS } from './NoticePrivacy.css';


export default function TermsAndConditions() {
    return (
      <div css={noticePrivacyCSS()}>
        <GenericHeader />
  
        <div className="ContainerNoticePrivacy">
          <h1>AVISO DE PRIVACIDAD</h1>
  
          <div className="ContainerTerms">
            <h4 style={{ margin: "0 .5rem" }}>PORTAL ELECTRÓNICO DE CONDUCE CAPITAL</h4>
  
            <p>
              <b>CONDUCE CAPITAL SAPI DE C.V.</b> (“PEICAR”), pone a su disposición el
              presente aviso de privacidad (el “Aviso de Privacidad”) que contiene
              la política bajo la cual se recabarán y tratarán los datos
              personales (“Datos Personales”) de las personas físicas (los
              “Titulares”) que se mencionan en el apartado V del presente Aviso de
              Privacidad a través de la página de internet de PEICAR
              <a
                  href="https://www.peicar.mx/"
                  style={{ fontWeight: "normal", color: "inherit" }}
                >
                  {" "}
                  www.peicar.mx{" "}
                </a>(el “Portal Electrónico”).
            </p>
  
            <h4 className="" style={{ margin: "0 .5rem" }}>
              Marco Normativo
            </h4>
  
            <p>
              PEICAR, emite el presente Aviso de Privacidad en cumplimiento a lo
              dispuesto por: (i) la Ley Federal de Protección de Datos Personales
              en Protección de los Particulares (“Ley”); (ii) el Reglamento de la
              Ley Federal de Protección de Datos Personales en Posesión de los
              Particulares (“Reglamento”), y (iii) los Lineamientos del Aviso de
              Privacidad publicados en el Diario Oficial de la Federación el 17 de
              enero de 2013 (“Lineamientos” y, en conjunto con la Ley y el
              Reglamento, los “Ordenamientos”).
            </p>
  
            <h4 className="" style={{ margin: "0 .5rem" }}>
              Objetivo
            </h4>
  
            <p>
              El objetivo del presente Aviso de Privacidad es delimitar los
              alcances y condiciones generales del tratamiento de Datos Personales
              y, hacerlos de conocimiento de sus Titulares, a fin de que estén en
              posibilidad de tomar decisiones informadas sobre el uso de dichos
              Datos Personales, y de mantener el control y disposición sobre
              ellos. Asimismo, el presente Aviso de Privacidad permite a PEICAR
              transparentar dicho tratamiento y con ello fortalecer el nivel de
              confianza de sus Titulares.
            </p>
  
            <h4 className="" style={{ margin: "0 .5rem" }}>
              Domicilio de PEICAR
            </h4>
  
            <p>
              PEICAR tiene su domicilio en Onimex lote 5 casa 32 el potrero 55 090
              Ecatepec edo de México (el “Domicilio”).
            </p>
  
            <div>
              <h4 className="" style={{ margin: "0 .5rem" }}>
                Datos Personales Recabados
              </h4>
  
              <p>
                Para el cumplimiento de este apartado, con fundamento en el
                artículo vigésimo segundo de los Lineamientos, PEICAR podrá
                solicitar y almacenar sus Datos Personales mediante las siguientes
                formas: (i) de manera directa cuando el Titular los proporcione a
                PEICAR, o bien, (ii) de manera indirecta, a través de otras
                fuentes de información pública, de la red deacceso mundial
                (“Internet”). <br /> <br /> Los Datos Personales que se tratarán,
                según las diferentes categorías de los mismos, son los que se
                señalan a continuación:
              </p>
  
              <p>
                ¿Cómo recopilamos datos personales? IPF solo tendrá acceso a los
                datos que tú, voluntaria y directamente, nos proporciones a través
                de forma digital, cómo puede ser correos electrónicos, llamadas, a
                través de la pagina de internet{" "}
                <a
                  href="https://www.peicar.mx/"
                  style={{ fontWeight: "normal", color: "inherit" }}
                >
                  {" "}
                  www.peicar.mx{" "}
                </a>{" "}
                Peicar, u otro medio de contacto digital, incluido el uso del
                sitio web o de nuestras redes sociales oficiales o a través de
                cualquier otro medio electrónico.
              </p>
              <ul>
                <li>
                  Generales: Todos aquellos que permitan identificar al Titular.
                </li>
                <li>
                  Profesionales: Todos aquellos que permitan conocer la
                  trayectoria, experiencia y capacidad profesional del Titular,
                  así como su reputación.
                </li>
                <li>
                  Habituales: aquellos patrones de navegación en el Portal
                  Electrónico que se utilicen para analizar y, en su caso,
                  ofrecerle nuevos productos y servicios.
                </li>
              </ul>
              <p>
                Asimismo, se hace del conocimiento del Titular que PEICAR no
                recaba Datos Personales sensibles del Titular.
              </p>
            </div>
  
            <h4 className="" style={{ margin: "0 .5rem" }}>
              Finalidades del Tratamiento de Datos Personales
            </h4>
  
            <p>
              PEICAR tratará los Datos Personales de las personas que (i)
              pretendan o celebren operaciones y soliciten los productos y
              servicios de PEICAR, (los “Clientes”), o (ii) personas que presten
              servicios a PEICAR, así como aquellos que tenga una relación de
              colaboración comercial con éste (los “Proveedores”), incluyendo a
              las personas que los representen, para las finalidades que se
              enlistan a continuación:
            </p>
  
            <div>
              <h4 className="" style={{ margin: "0 .5rem" }}>
                Finalidades para los Clientes
              </h4>
  
              <p>
                Finalidades que dan origen y son necesarias para la existencia,
                mantenimiento y cumplimiento de la relación jurídica entre PEICAR
                y el Cliente:
              </p>
              <ul>
                <li>
                  Autentificar o corroborar la identidad del Cliente y demás
                  información proporcionada a PEICAR.{" "}
                </li>
                <li>
                  Mantener la comunicación que resulte necesaria con el Cliente,
                  para atender las consultas de los Clientes y ofrecer los
                  detalles de los productos y servicios de PEICAR.
                </li>
                <li>
                  Gestionar las oportunidades necesarias para celebrar contratos
                  de crédito, factoraje financiero, entre otros, así como los
                  instrumentos jurídicos accesorios a los mismos, así como para
                  alcanzar el objeto de dichos contratos.
                </li>
                <li>
                  Mantener actualizado el expediente del Cliente, cumplir
                  disposiciones de conocimiento del cliente y prevención de lavado
                  de dinero, conforme a lo previsto por la legislación en la
                  materia.{" "}
                </li>
                <li>
                  Elaborar estadísticas y reportes de los servicios prestados por
                  PEICAR con el objeto de llevar un control interno de dichos
                  servicios, así como para dar seguimiento puntual de los mismos.
                </li>
                <li>Dar cumplimiento a la normatividad aplicable.</li>
              </ul>
              <p>Finalidades que NO dan origen y NO son necesarias para la existencia, mantenimiento y cumplimiento de la relación jurídica entre PEICAR y el Cliente.</p>
              <ul>
                <li>
                Elaborar encuestas, estadísticas y reportes.
                </li>
                <li>
                  Notificar y ofrecer promociones, descuentos y campañas
                  publicitarias de productos o servicios.
                </li>
                <li>Fines mercadológicos y publicitarios.</li>
                <li>
                  Informar sobre nuevos productos o servicios, así como
                  actividades o productos afines o análogos a los del interés del
                  propio Cliente.
                </li>
                <li>
                  Informar sobre cambios en los productos o servicios de PEICAR.
                </li>
              </ul>
  
              <p>
                Para efectos del presente aviso, así como en caso de que éste no
                se haga del conocimiento del Cliente de manera directa o personal,
                se hace del conocimiento del Cliente que cuenta con un plazo de 5
                (cinco) días hábiles para que, de ser el caso, manifieste su
                negativa a PEICAR, para el tratamiento de sus datos personales con
                respecto a las finalidades incluidas en este inciso B) del
                apartado V.1 mediante una solicitud que, bajo el rubro de
                “Negativa de Tratamiento de Datos Personales Secundarios”, el
                Titular dirija al Domicilio o a la dirección de correo electrónico
                señalada en el apartado VII del presente Aviso de Privacidad,
                misma que surtirá sus efectos dentro de los 3 (tres) días hábiles
                siguientes a la recepción de dicha solicitud.
              </p>
            </div>
  
            <div>
              <h4 className="" style={{ margin: "0 .5rem" }}>
                Finalidades para los Proveedores
              </h4>
  
              <p>
                Finalidades que dan origen y son necesarias para la
                existencia,mantenimiento y cumplimiento de la relación jurídica
                entre PEICAR y el Proveedor:
              </p>
              <ul>
                <li>
                  Autentificar o corroborar la identidad del Proveedor, así como
                  la ubicación de su establecimiento.
                </li>
                <li>
                  Analizar la trayectoria, experiencia y capacidad profesional del
                  Proveedor, así como su solvencia moral, para determinar la
                  posible contratación del bien y/o servicio de que se trate.
                </li>
                <li>
                  Mantener la comunicación que resulte necesaria para para atender
                  las consultas y propuestas de los Proveedores y ofrecer los
                  detalles de negociación correspondientes.
                </li>
                <li>
                  Gestionar las oportunidades necesarias para celebrar contratos
                  de colaboración, prestación y/o suministro de servicios, entre
                  otros, así como los instrumentos jurídicos accesorios a los
                  mismos, así como para alcanzar el objeto de dichos contratos.
                </li>
                <li>
                  Elaborar estadísticas y reportes de los servicios prestados a
                  PEICAR con el objeto de llevar un control interno de dichos
                  servicios, así como para dar seguimiento puntual de los mismos.
                </li>
                <li>Dar cumplimiento a la normatividad aplicable.</li>
              </ul>
              <p>
                Finalidades que NO dan origen y NO son necesarias para la
                existencia, mantenimiento y cumplimiento de la relación jurídica
                entre PEICAR y el Proveedor.
              </p>
              <ul>
                <li>Elaborar encuestas, estadísticas y reportes.</li>
                <li>
                  Referencia de los productos y servicios del Proveedor con las
                  sociedades relacionadas de PEICAR.
                </li>
              </ul>
  
              <p>
                Para efectos del presente aviso, así como en caso de que éste no
                se haga del conocimiento del Proveedor de manera directa o
                personal, se hace del conocimiento del Proveedor que cuenta con un
                plazo de 5 (cinco) días hábiles para que, de ser el caso,
                manifieste su negativa a PEICAR, para el tratamiento de sus datos
                personales con respecto a las finalidades incluidas en este inciso
                B) del apartado V.2 mediante una solicitud que, bajo el rubro de
                “Negativa de Tratamiento de Datos Personales Secundarios”, el
                Titular dirija al Domicilio o a la dirección de correo electrónico
                señalada en el apartado VII del presente Aviso de Privacidad,
                misma que surtirá sus efectos dentro de los 3 (tres) días hábiles
                siguientes a la recepción de dicha solicitud.
              </p>
            </div>
  
            <div>
              <h4 className="" style={{ margin: "0 .5rem" }}>
                Remisión de Datos Personales
              </h4>
  
              <p>
                El tratamiento que PEICAR realiza de los Datos Personales puede
                involucrar la remisión nacional o internacional de éstos. En
                virtud de lo anterior, acontinuación, se establecen los terceros
                receptores o destinatarios de los Datos Personales, indicando para
                ello, su tipo, categoría o sector de actividad.
              </p>
              <ul>
                <li>
                  Empresas controladoras, filiales o subsidiarias de PEICAR.
                </li>
                <li>
                  Terceros respecto de los cuales PEICAR requiera una prestación
                  de servicios, así como asesoría jurídica, para el contrato o
                  convenio de que se trate.
                </li>
                <li>
                  Autoridades judiciales y/o administrativas frente a las cuales
                  PEICAR esté obligado en términos de ley.
                </li>
              </ul>
  
              <p>
                En todos los casos PEICAR dará a conocer a los terceros el
                contenido del presente Aviso de Privacidad. Todo lo anterior, en
                el entendido de que PEICAR puede libremente hacer remisiones de
                los Datos Personales a sus controladores, filiales, subsidiarias
                y/o prestadores de servicios para fines del propio PEICAR, en
                virtud de que, bajo los Ordenamientos, estos terceros serían tan
                solo sus encargados.
              </p>
            </div>
  
            <div>
              <h4 className="" style={{ margin: "0 .5rem" }}>
                Medios y Procedimiento para el Ejercicio de los Derechos de
                Acceso, Rectificación, Cancelación u Oposición
              </h4>
  
              <p>
                De conformidad con los Ordenamientos, el Titular podrá ejercitar
                frente a PEICAR sus derechos de acceso, rectificación, cancelación
                u oposición (los “Derechos ARCO”), respecto a los Datos Personales
                que le conciernen. Para efectos de lo anterior, el Titular deberá
                presentar ante PEICAR una solicitud mediante un escrito libre
                dirigido a la Dirección General de PEICAR y deberá contener y
                acompañar lo siguiente: (i) nombre del Titular y domicilio u otro
                medio para comunicarle la respuesta a su solicitud; (ii) copia del
                documento de identificación del Titular, así como el original de
                la misma para su cotejo o, en su caso, tratándose del
                representante del Titular, además de lo anterior, los documentos
                que acrediten la identidad del representante, así como el
                instrumento público o carta poder firmada ante dos testigos, en el
                que consten las facultades otorgadas, o declaración en
                comparecencia personal del Titular; (iii) descripción clara y
                precisa de los Datos Personales respecto de los que se busca
                ejercer alguno de los derechos de rectificación, cancelación u
                oposición, y (iv) cualquier otro elemento o documento que facilite
                la localización de los Datos Personales. Dicha solicitud deberá
                presentarse en el Domicilio en un horario de 10:00 a 17:00 horas,
                durante días hábiles, o en cualquier momento mediante correo
                electrónico dirigido a la dirección electrónica siguiente:
                contacto@peicar.com.mx, siempre que se presenten los instrumentos
                electrónicos debidamente certificados que sustituyan la
                identificación del Titular o, en su caso, de su representante. El
                ejercicio de los Derechos ARCO será gratuito, debiendo cubrir el
                Titular únicamente los gastos de envío, reproducción (copia
                simple) y, en su caso, certificación de documentos. No obstante,
                si el mismo Titular reitera su solicitud en un periodo menor a 12
                (doce) meses, los costos serán el equivalente a 3 (tres) veces la
                Unidad de Medida y Actualización vigente, a menos que existan
                modificaciones sustanciales al Aviso de Privacidad que motiven
                nuevas consultas.
              </p>
  
              <p>
                PEICAR comunicará al Titular en un plazo máximo de 20 (veinte)
                días hábilescontados desde la fecha en que se haya recibido la
                solicitud del DerechoARCO que corresponda, la determinación
                adoptada a efecto de que, si resultaprocedente, se haga efectiva
                la misma dentro de los 15 (quince) díashábiles siguientes a la
                fecha en que se comunique la respuesta. El plazopodrá ser ampliado
                por una sola ocasión, por cada solicitud, hasta por unplazo
                adicional de 15 (quince) días hábiles, siempre que PEICAR
                justifiquela ampliación al Titular, lo cual deberá ser notificado
                antes delvencimiento del plazo original. Para tal efecto, PEICAR
                anotará en el acusede recibo que entregue el Titular la
                correspondiente fecha de recepción.
              </p>
              <p>
                El plazo señalado en el párrafo anterior se interrumpirá en caso
                de que PEICAR requiera información adicional al Titular, por ser
                la información entregada originalmente, sea insuficiente o errónea
                para atender la solicitud, o bien, no se acompañen los documentos
                antes indicados. Para tal efecto, PEICAR le podrá requerir al
                Titular, por una vez y dentro de los 5 (cinco) días hábiles
                siguientes a la recepción de la solicitud, aporte los elementos o
                documentos necesarios para dar trámite a la misma, contando, por
                su parte, el Titular con 10 (diez) días hábiles para atender el
                requerimiento, contados a partir del día siguiente en que lo haya
                recibido. Si el Titular no diere respuesta en dicho plazo se
                tendrá por no presentada la solicitud correspondiente. Por el
                contrario, en caso de que el Titular atienda el requerimiento de
                información, el plazo para que PEICAR dé respuesta a la solicitud,
                empezará a correr al día siguiente de que el Titular haya atendido
                el requerimiento de información adicional.
              </p>
              <p>
                Las respuestas que PEICAR le otorgue a los Titulares que hubieren
                ejercido sus Derechos ARCO, se realizarán por el mismo medio en
                que se formuló la solicitud, versando únicamente sobre los Datos
                Personales que específicamente se hayan indicado en la solicitud
                en cuestión y deberá presentarse en formato legible y
                comprensible.
              </p>
              <p>
                Cuando el acceso a los Datos Personales sea en un lugar físico que
                designe PEICAR, éste le otorgará al Titular un periodo de 15
                (quince) días hábiles para que éste pueda presentarse a
                consultarlos. Transcurrido ese plazo, sin que el Titular haya
                acudido, será necesaria la presentación de una nueva solicitud.
              </p>
              <p>
                Cuando PEICAR niegue el ejercicio de cualquiera de los Derechos
                ARCO, deberá justificar su respuesta, informándole al Titular el
                derecho que le asiste para solicitar el inicio del procedimiento
                ante el Instituto Nacional de Transparencia, Acceso a la
                Información y Protección de Datos Personales.
              </p>
            </div>
  
            <div>
              <h4 className="" style={{ margin: "0 .5rem" }}>
                Revocación del Consentimiento
              </h4>
              <p>
                El consentimiento que el Titular otorgue al presente Aviso de
                Privacidad podrá ser revocado en cualquier tiempo, sin que se le
                atribuyan efectos retroactivos. La revocación del consentimiento
                que pretendiera realizar el Titular, deberá hacerlo conforme a los
                medios y procedimiento consignados en el numeral VII anterior.
              </p>
            </div>
  
            <div>
              <h4 className="" style={{ margin: "0 .5rem" }}>
                Opciones y Medios para Limitar el Uso o Divulgación de Datos
                Personales
              </h4>
              <p>
                Con el objeto de limitar el uso o divulgación de los Datos
                Personales, PEICAR resguarda dichos Datos Personales bajo
                programas y/o archivos de cómputo con acceso limitado únicamente a
                personas que, con motivo de sus funciones, se les otorgan
                facultades para ello.{" "}
              </p>
  
              <p>
                Por lo que respecta a documentos físicos que contengan Datos
                Personales, PEICAR los resguarda en archivos bajo llave, a los
                cuales únicamente tiene acceso el personal que con motivo de sus
                funciones se le otorgan facultades para ello.
              </p>
  
              <p>
                Tanto en el caso de Datos Personales contenidos en medios
                electrónicos como en documentos físicos, PEICAR utiliza las mismas
              </p>
  
              <p>
                Asimismo, PEICAR suscribe con todo su personal convenios de
                confidencialidad, en los que se contempla que los Datos Personales
                a los que acceda en ejercicio de sus funciones, es información
                confidencial y por tanto, en caso de divulgar dicha información
                confidencial se hará acreedor al pago de daños y perjuicios, así
                como a las sanciones penales que procedan.
              </p>
  
              <p>
                A su vez, PEICAR ha implementado políticas y procesos internos
                aplicables a su personal, a través de los cuales los Datos
                Personales son utilizados por un mínimo de personas, limitándose
                el uso de los medios de reproducción, y generándose la obligación
                de destruir todas aquellas copias o reproducciones de documentos
                que contengan Datos Personales que no sean estrictamente
                indispensables para el adecuado desempeño de las funciones del
                personal de PEICAR.
              </p>
  
              <p>
                Finalmente, PEICAR, por la presente sección, informa a los
                Titulares que podrán inscribirse en el Registro Público de
                Usuarios (REUS) conforme a la Ley de Protección y Defensa al
                Usuario de Servicios Financieros, con la finalidad de limitar el
                uso y divulgación de sus Datos Personales, a través de los medios
                que se establecen en la siguiente página de Internet:{" "}
                <a
                  style={{
                    fontWeight: "normal",
                    color: "inherit",
                  // textDecoration: "underline",
                  }}
                  href="https://www.gob.mx/tramites/ficha/registro-publico-de-usuarios-reus-para-personas-fisicas/CONDUSEF2536"
                >
                  https://www.gob.mx/tramites/ficha/registro-publico-de-usuarios-reus-para-personas-fisicas/CONDUSEF2536
                </a>{" "}
              </p>
            </div>
  
            <div>
              <h4 className="" style={{ margin: "0 .5rem" }}>
                Cambios al Aviso de Privacidad
              </h4>
              <p>
                PEICAR tiene el derecho de efectuar en cualquier momento
                modificaciones o actualizaciones al presente Aviso de Privacidad,
                con motivo de reformas legislativas, políticas internas o nuevos
                requerimientos para la prestación u ofrecimiento de sus servicios.
                Estas modificaciones se realizarán y estarán disponibles para los
                Titulares a través del Portal Electrónico y estarán vigentes desde
                el momento de su publicación en el mismo.
              </p>
              <p>
                Para mayor información visite {" "}
                <a style={{
                    fontWeight: "normal",
                    color: "inherit",}} href="https://home.inai.org.mx/">
                  {" "}
                  https://home.inai.org.mx/{" "}
                </a>
              </p>
            </div>
  
            <div>
              <h4 className="" style={{ margin: "0 .5rem" }}>
                Política de Cookies
              </h4>
              <p>
                Las cookies son archivos de texto que son almacenados en el equipo
                de cómputo o en el teléfono móvil inteligente (smartphone)
                utilizado por el Titular al hacer uso del Portal Electrónico. Las
                cookies ayudan a PEICAR a brindarle al Titular una mejor
                experiencia cuando utiliza el Portal Electrónico y le permiten
                mejorar dicha experiencia. PEICAR usa cookies para analizar el
                flujo de información, identificar a los usuarios registrados,
                personalizar sus servicios, el contenido y la publicidad,
                facilitar la navegación de
              </p>
              <p>
                {" "}
                los usuarios registrados, medir la efectividad promocional,
                verificar los contenidos más visitados y promover la confianza y
                seguridad en dicho Portal Electrónico y poner a su disposición los
                valores predeterminados de las funciones del Portal Electrónico
                configuradas por el mismo PEICAR, así como adaptar eventualmente
                las herramientas más relevantes para los Titulares. En ese
                sentido, a través de las cookies se podrán obtener datos
                personales del Titular.
              </p>
  
              <p>
                Cada Titular puede aceptar o rechazar el uso de cookies mediante
                la configuración para tal efecto en su equipo de cómputo o
                smartphone utilizado, sin embargo, es importante que los Titulares
                tengan en cuenta que, si no aceptan el uso de cookies, algunas
                funciones del Portal Electrónico pueden no estar plenamente
                disponibles, debido a que algunos de los servicios o contenido del
                propio Portal Electrónico únicamente están disponibles mediante el
                uso de cookies. El Titular podrá desactivar el uso de cookies
                siguiendo para tal efecto el procedimiento señalado en la
                configuración del navegador, equipo de cómputo y/o smartphone que
                utilice para navegar en el Portal Electrónico. Para tales efectos,
                el Titular podrá consultar los sitios siguientes:
              </p>
              <div className="ContainerExplorer" style={{ display: "flex" }}>
                <ul className="ListaUrl">
            <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank">Firefox</a></li>
            <li><a href="https://support.microsoft.com/es-mx/help/17442/windows-internet-explorer-delete-manage-cookies" target="_blank">Internet Explorer</a></li>
            <li><a href="https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=es" target="_blank">Google Chrome</a></li>
            <li><a href="https://support.apple.com/kb/ph21411?locale=es_ES" target="_blank">Safari</a></li>
        </ul>
                {/* <div>
                  <p>Firefox:</p>
                  <p>Internet Explorer</p>
                  <p>Google Chrome</p>
                  <p>Safari</p>
                </div>
                <ul className="ListaUrl">
                  <li>
                    <a
                      style={{
                        fontWeight: "normal",
                        color: "inherit",
                        // textDecoration: "underline",
                      }}
                      href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias"
                    >
                      https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias
                    </a>
                  </li>
                  <li>
                    <a
                      style={{
                        fontWeight: "normal",
                        color: "inherit",
                        // textDecoration: "underline",
                      }}
                      href="https://support.microsoft.com/es-mx/help/17442/windows-internet-explorer-delete-manage-cookies"
                    >
                      https://support.microsoft.com/es-mx/help/17442/windows-internet-explorer-delete-manage-cookies
                    </a>
                  </li>
                  <li>
                    <a
                      style={{
                        fontWeight: "normal",
                        color: "inherit",
                        // textDecoration: "underline",
                      }}
                      href="https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=es"
                    >
                      https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=es
                    </a>
                  </li>
                  <li>
                    <a
                      style={{
                        fontWeight: "normal",
                        color: "inherit",
                        // textDecoration: "underline",
                      }}
                      href="https://support.apple.com/kb/ph21411?locale=es_ES"
                    >
                      https://support.apple.com/kb/ph21411?locale=es_ES
                    </a>
                  </li>
                </ul> */}
              </div>
  
              <p>Fecha de última actualización: 20 de marzo de 2024.</p>
            </div>
  
            <div>
              <h4 className="" style={{ margin: "0 .5rem" }}>
                Términos y condiciones
              </h4>
              <p>
                Este acuerdo detalla las disposiciones generales (los "Términos y
                Condiciones Generales") que se aplican al uso de los servicios
                proporcionados por PEICAR, ("Los Servicios") a través del sitio
                web
                <a
                   href="https://www.peicar.mx/"
                  style={{ fontWeight: "normal", color: "inherit" }}
                >
                  {" "}
                  www.peicar.mx{" "}
                </a>
                (el "Sitio"). Estos términos son referidos tanto en el Sitio como
                en estos Términos y Condiciones Generales, de forma intercambiable
                como PEICAR. Aquellas personas que deseen acceder y/o utilizar el
                sitio y sus servicios están obligadas a cumplir con estos Términos
                y Condiciones Generales, así como con todas las políticas y
                principios que rigen PEICAR y que se incorporan por referencia.
              </p>
              <p>
                Quienes no acepten estos Términos y Condiciones Generales, los
                cuales son obligatorios y vinculantes, deben abstenerse de
                utilizar el Sitio y/o los Servicios.
              </p>
              <p>
                Es responsabilidad del usuario leer, comprender y aceptar todas
                las condiciones establecidas en los Términos y Condiciones
                Generales, así como en el Aviso de Privacidad y otros documentos
                referenciados, antes de utilizar los servicios como Usuario de
                PEICAR.
              </p>
            </div>
  
            <div>
              <h4 className="" style={{ margin: "0 .5rem" }}>
                Legitimación
              </h4>
              <p>
                Los Servicios están disponibles solo para personas con capacidad
                legal para contratar. No podrán usarlos menores de edad, personas
                sin esta capacidad o Usuarios de PEICAR suspendidos temporal o
                permanentemente. Si el Usuario representa a una Empresa, debe
                tener autoridad para contratar en su nombre y ser responsable en
                términos de este Acuerdo, conforme al artículo 2554 del Código
                Civil Federal.
              </p>
            </div>
  
            <div>
              <h4 className="" style={{ margin: "0 .5rem" }}>
                Datos personales
              </h4>
              <p>
                Es necesario proporcionar información personal válida en el
                formulario de solicitud para acceder a los servicios del Sitio.
                Los Usuarios son responsables de la veracidad y actualización de
                sus Datos Personales. PEICAR no garantiza la certeza de esta
                información y se reserva el derecho de solicitar comprobantes
                adicionales.
              </p>
            </div>
  
            <div>
              <h4 className="" style={{ margin: "0 .5rem" }}>
                Verificación de identidad{" "}
              </h4>
              <p>
                PEICAR no puede confirmar la identidad de cada Usuario en
                Internet, siendo responsabilidad exclusiva de los mismos.{" "}
              </p>
            </div>
  
            <div>
              <h4 className="" style={{ margin: "0 .5rem" }}>
                Privacidad de la información{" "}
              </h4>
              <p>
                Los Datos Personales de los Usuarios se procesan y almacenan con
                altos estándares de seguridad. Para más detalles, consultar el
                Aviso de Privacidad de PRESTEMOS.{" "}
              </p>{" "}
            </div>
  
            <div>
              <h4 className="" style={{ margin: "0 .5rem" }}>
                Modificaciones{" "}
              </h4>
              <p>
                PEICAR puede modificar los Términos y Condiciones, siendo
                efectivos diez días después de su publicación. Los Usuarios deben
                comunicar si no aceptan los cambios en cinco días.
              </p>{" "}
            </div>
  
            <div>
              <h4 className="" style={{ margin: "0 .5rem" }}>
                Responsabilidad{" "}
              </h4>
              <p>
                Se recomienda precaución al operar con otros Usuarios. PEICAR no
                se hace responsable por reclamos legales entre Usuarios.{" "}
              </p>{" "}
            </div>
  
            <div>
              <h4 className="" style={{ margin: "0 .5rem" }}>
                Sanciones y violaciones
              </h4>
              <p>
                PEICAR puede tomar medidas contra Usuarios que incumplan los
                términos, incluyendo suspensión o cancelación de servicios.{" "}
              </p>{" "}
            </div>
  
            <div>
              <h4 className="" style={{ margin: "0 .5rem" }}>
                Propiedad intelectual{" "}
              </h4>
              <p>
                Los contenidos del Sitio son propiedad de PEICAR y están
                protegidos por leyes de propiedad intelectual. El uso indebido
                está prohibido sin autorización escrita.
              </p>{" "}
            </div>
  
            <div>
              <h4 className="" style={{ margin: "0 .5rem" }}>
                Fallas en el sistema{" "}
              </h4>
              <p>
                PEICAR no se hace responsable por daños derivados de fallas
                técnicas del Sitio. Los Usuarios no pueden imputar responsabilidad
                por dificultades técnicas o virus.{" "}
              </p>{" "}
            </div>
  
            <div>
              <h4 className="" style={{ margin: "0 .5rem" }}>
                Indemnización
              </h4>
              <p>
                Los Usuarios indemnizarán a PEICAR por reclamos derivados de sus
                actividades en el Sitio.
              </p>{" "}
            </div>
  
            <div>
              <h4 className="" style={{ margin: "0 .5rem" }}>
                Jurisdicción y ley aplicable
              </h4>
              <p>
                Este acuerdo se rige por las leyes mexicanas y se somete a la
                jurisdicción de los tribunales competentes en la Ciudad de México.{" "}
              </p>{" "}
            </div>
          </div>
        </div>
  
        <Footer />
      </div>
    );
  }
  

// export default function NoticePrivacy() {
//     return (
//         <div css={noticePrivacyCSS}>
            
//             <GenericHeader />

//             <div className="ContainerNoticePrivacy">
//                 <h1>Aviso de Privacidad Simplificado</h1>

//                 <p>
//                     Con fundamento en las disposiciones vigentes de la Ley Federal de
//                     Protección de Datos Personales en Posesión de los Particulares,
//                     publicada en el Diario Oficial de la Federación el 5 de julio de 2010
//                     (en adelante la <u>“Ley”</u>), informamos a la persona titular y a quien
//                     corresponden los datos personales (el <u>“Titular”</u>) que cierta parte de
//                     su información personal, incluyendo sin limitación alguna nombre
//                     completo, número de teléfono, domicilio completo, datos de pago o
//                     transferencias, información y antecedentes crediticios y financieros,
//                     datos migratorios, patrimoniales, registro federal de contribuyentes,
//                     clave única de registro de población, número de afiliación del seguro
//                     social, números de tarjetas de crédito o débito y cuentas bancarias,
//                     dirección IP, correo electrónico, entre otros, (en adelante los <u>“Datos
//                     Personales”</u>) que nos proporcione ya sea de manera personal o bien
//                     directamente por cualquier medio electrónico, óptico, sonoro, visual o
//                     través de cualquier otra tecnología o por cualquier otro medio en el
//                     curso de sus interacciones con <b>CONDUCE CAPITAL S.A.P.I S.A. de C.V.</b>
//                     (en adelante <u>“Peicar”</u>), puede ser recopilada y almacenada por <u>Peicar</u>
//                     con la única finalidad de llevar a cabo las actividades relacionadas
//                     con y la celebración de contratos de arrendamiento puro, arrendamiento
//                     financiero o financiamiento y aquellas relacionados o similares a
//                     éstas con el Titular, así como para identificar correctamente al
//                     Titular en nuestros sistemas y hacerle llegar comunicaciones en
//                     relación con la finalidad del presente aviso, llevar a cabo la
//                     facturación correspondiente y formalizar en contratos u otros
//                     documentos legales, o de cualquier otra índole, la relación que se
//                     genere entre el Titular y Peicar o con terceros derivado de la
//                     finalidad del presente aviso.
//                 </p>

//                 <p>
//                     Utilizaremos sus Datos Personales únicamente para los propósitos antes
//                     indicados. No comercializaremos sus Datos Personales a otras empresas
//                     dentro del curso normal de nuestro negocio. Sin embargo, es posible
//                     que ocasionalmente sus Datos Personales sean revelados a otra empresa,
//                     como parte de un proceso de inversión, co-inversión, adquisición,
//                     fusión, asociación, o proceso similar, en cuyo caso esa divulgación
//                     estará sujeta a nuestra política de privacidad que se encuentre en
//                     vigor en dicha fecha y mantendremos, respecto de dichos datos, el
//                     tratamiento de privacidad o confidencialidad que sea requerido en
//                     términos de la legislación aplicable y de dicha política.
//                     Ocasionalmente sus Datos Personales serán transferidos a nuestras
//                     empresas afiliadas o compañías que nos presten servicios relacionados
//                     a las finalidades de uso de Datos Personales previstos en este aviso.
//                 </p>

//                 <p>
//                     En relación con los Datos Personales que recabemos, nos comprometemos
//                     a que el tratamiento que se dé a los mismos sea el necesario para
//                     lograr las finalidades mencionadas en este aviso y como consecuencia
//                     de la prestación de servicios de Peicar al Titular, y a tratar dichos
//                     datos de conformidad con los usos y prácticas comunes para proteger la
//                     confidencialidad de los mismos.
//                 </p>

//                 <p>
//                     El acceso a los Datos Personales del Titular está limitado a aquellas
//                     personas que necesitan acceder o sea conveniente que tengan acceso a
//                     sus Datos Personales para lograr las finalidades de uso de dicha
//                     información indicadas en el presente aviso. A pesar de que empleamos
//                     las precauciones suficientes para proteger su información personal, no
//                     podemos garantizar una seguridad absoluta.
//                 </p>

//                 <p>
//                     El Titular manifiesta su consentimiento para que, en caso de contratar
//                     los servicios prestados por Peicar en materia de arrendamiento de
//                     vehículos, Peicar pueda colocar en el vehículo un equipo de
//                     geolocalización con el único propósito de rastrear dicho vehículo ante
//                     eventos de pérdidas o procedimientos legales que así lo requieran, sin
//                     que por dicha causa se afecten los derechos personales del titular
//                     toda vez que dicho equipo de geolocalización tiene un alcance limitado
//                     a conocer la localización y paradero del vehículo, datos que se
//                     encuentran vinculados al mencionado vehículo, sin tener un carácter
//                     personal por no considerarse Datos Personales ni Datos Personales
//                     Sensibles en términos de la Ley.
//                 </p>

//                 <p>
//                     Para limitar el uso de sus Datos Personales, ejercer los derechos de
//                     acceso, rectificación, cancelación, oposición a que se refiere la Ley,
//                     y, en su caso, para limitar el uso o divulgación de la información que
//                     nos proporcione o solicitar cualquier aclaración respecto de nuestra
//                     política de privacidad, envíenos una comunicación por escrito a la
//                     siguiente dirección de correo electrónico: <a href="maito:hola@peicar.com.mx"> hola@peicar.com.mx</a>
//                 </p>

//                 <p>
//                     Cualquier cambio o actualización a los términos del presente aviso de
//                     privacidad será notificado al Titular a través de los medios que de
//                     tiempo en tiempo determine Peicar.
//                 </p> 

//                 <p>
//                     <b>CONDUCE CAPITAL S.A.P.I. de C.V.</b>, con domicilio en <u>Lote 5 casa 32, El
//                     Potrero, Ecatepec Estado de México, CP 55090</u>, es la sociedad
//                     responsable de recabar sus Datos Personales, así como del tratamiento
//                     que se dé a los mismos y de su protección conforme a la Ley.
//                 </p>
//             </div>

//             <Footer />
//         </div>
//     );
// }
